module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 413
// module chunks = 0